<div class="form-container">
    <div class="row form-group">
        <label class="col-sm-3">{{ 'common.personal-information.first-name' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.FirstName" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3">{{ 'common.personal-information.last-name' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.LastName" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3">{{ 'common.personal-information.org-name' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.OrgName" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3">{{ 'common.personal-information.address1' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.Address1" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3">{{ 'common.personal-information.address2' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.Address2" (change)="emitChanges()" />
        </div>
    </div>
    
    <div class="row form-group">
        <label class="col-sm-3" for="registrationCity">{{ 'revenue.credit-card-input.city-label' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.City" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3" for="registrationState">{{ 'revenue.credit-card-input.state-label' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <wl-state-selector [displayAbbreviation]="true" [(ngModel)]="achInfo.ContactInfo.State"></wl-state-selector>
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3" for="registrationZip">{{ 'revenue.credit-card-input.zip-label' | translate | titlecase }}</label>
        <div class="col-sm-3">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.Zip" (change)="emitChanges()" />
        </div>
    </div>
    <div class="row form-group">
        <label class="col-sm-3" for="registrationCountry">{{ 'revenue.credit-card-input.country-label' | translate | titlecase }}</label>
        <div class="col-sm-6">
          <input class="form-control" type="text" [(ngModel)]="achInfo.ContactInfo.Country" (change)="emitChanges()" />
        </div>
    </div>

    <!-- Raw bank fields - the form for every non-Preczn gateway (AuthNet, CardConnect). Unchanged
         from before the Preczn branch was added; it simply no longer renders when the resolved
         gateway is a Preczn one. -->
    <ng-container *ngIf="!usePreczn">
        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.name-on-bank-account-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input class="form-control" type="text" [(ngModel)]="achInfo.NameOnAccount" (change)="emitChanges()" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.bank-name-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input type="text" [(ngModel)]="achInfo.BankName" class="form-control" (change)="emitChanges()" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.routing-number-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input type="text" [(ngModel)]="achInfo.RoutingNumber" class="form-control" (change)="emitChanges()" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.account-number-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input type="text" [(ngModel)]="achInfo.AccountNumber" class="form-control" (change)="emitChanges()" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.account-type-label' | translate | titlecase }}
            </label>
            <div class="form-inline">
                <p-select
                placeholder="{{ 'common.select' | translate }}"
                [options]="bankAccountTypes"
                [(ngModel)]="achInfo.AccountType"
                (onChange)="emitChanges()"
                ></p-select>
            </div>
        </div>
    </ng-container>

    <!-- Preczn-hosted bank fields. The SDK finds these by data-preczn attribute inside the element
         whose id is precznFormId, and getAchToken(precznFormId) reads them directly.
         Deliberately NO name and NO id on any data-preczn field, and no ngModel: bank data must
         stay out of the surrounding form's payload and out of this component's dto. Modelled on the
         Portal widget's block (Atlas.Spa.Portal/.../ach-input.component.html:87-111). -->
    <div *ngIf="usePreczn" [id]="precznFormId">
        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.account-type-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <select class="form-control" data-preczn="accountType">
                    <option value="personalChecking">Personal Checking</option>
                    <option value="personalSavings">Personal Savings</option>
                    <option value="corporateChecking">Corporate Checking</option>
                    <option value="corporateSavings">Corporate Savings</option>
                </select>
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.routing-number-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input class="form-control" data-preczn="routingNumber" type="text" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-3 control-label">
            {{ 'revenue.ach-input.account-number-label' | translate | titlecase }}
            </label>
            <div class="col-sm-6">
                <input class="form-control" data-preczn="accountNumber" type="text" />
            </div>
        </div>

        <input type="hidden" data-preczn="bankCountry" value="USA" />
    </div>
</div>
  